"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function MacMulticolorFilled(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__mac-multicolor-filled__clip0_13467_152)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__mac-multicolor-filled__paint0_linear_13467_152)",
    d: "M16 1.684v12.632a1.269 1.269 0 01-1.264 1.284h-4.98c-.72-2.536-.748-6.244-.748-6.244H6.316c.083-3.04.622-6.049 1.6-8.928h6.8A1.264 1.264 0 0116 1.684z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__mac-multicolor-filled__paint1_linear_13467_152)",
    d: "M9.756 15.6H1.264A1.267 1.267 0 010 14.316V1.684A1.264 1.264 0 011.264.42h6.668a29.78 29.78 0 00-1.66 8.892h2.644s.08 3.804.84 6.288z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0095C9",
    d: "M9.756 15.6a16.8 16.8 0 01-.708-3.1c-.14-.984-.24-1.976-.284-2.976L6.4 9.528h-.216V9.32c.005-.765.05-1.528.136-2.288.088-.752.188-1.508.344-2.252.156-.744.32-1.484.532-2.216.212-.732.456-1.444.732-2.148-.184.732-.4 1.464-.536 2.2-.136.736-.296 1.476-.4 2.216-.104.74-.204 1.492-.268 2.24-.06.676-.104 1.356-.108 2.032H9.14v.192c.024 1.044.072 2.104.16 3.148.085 1.06.237 2.115.456 3.156z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M8.204 12a8.316 8.316 0 01-5.2-1.892.26.26 0 01-.036-.368.256.256 0 01.364-.036c2.464 2.024 6.444 2.68 9.288 0a.26.26 0 01.438.199.26.26 0 01-.082.181A6.888 6.888 0 018.204 12zM11.7 5.316a.26.26 0 01-.26-.26v-.8a.26.26 0 01.52 0v.8a.261.261 0 01-.26.26zM4.5 5.316a.26.26 0 01-.26-.26v-.8a.26.26 0 01.52 0v.8a.26.26 0 01-.26.26z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__mac-multicolor-filled__paint0_linear_13467_152",
    x1: 11.156,
    x2: 11.156,
    y1: 15.58,
    y2: 0.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCE4EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__mac-multicolor-filled__paint1_linear_13467_152",
    x1: 4.876,
    x2: 4.876,
    y1: 15.58,
    y2: 0.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0088C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BDFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__mac-multicolor-filled__clip0_13467_152"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V16H0z"
  }))));
}

MacMulticolorFilled.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
MacMulticolorFilled.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = MacMulticolorFilled;
exports["default"] = _default;